<template>
  <div>
    <div
      class="bg-test-tag"
      v-if="this.$store.state.template.survey.phase == 'TEST'"
    >
      <p class="mb-0 text-center">
        <small
          ><i class="fa fa-exclamation-circle mr-2" />{{ $t('homolog_mode') }}</small
        >
      </p>
    </div>
    <div id="header" class="container-fluid border-bottom-light">
      <nav
        class="navbar navbar-expand-lg static-top navbar-dark"
        :class="{
          'navbar-dark': !secondaryHeader || templateStyle.surveyBackground,
        }"
      >
        <div
          class="container border-left-light py-4 d-md-flex align-items-end pt-md-2 pb-md-3 px-lg-0"
        >
          <!-- Logos section-->
          <section
            class="col-12 col-md-6 text-center px-5 d-flex align-items-center justify-content-center
                          justify-content-md-start"
            style="z-index: 100"
          >
            <a
              v-for="(item, index) in templateLogos"
              :key="index"
              :href="item.href ? item.href : '#/home'"
              :target="item.href.startsWith('http') ? '_blank' : ''"
              class="navbar-brand mr-md-5 pb-0 logos"
            >
              <div v-if="item.logo || item.logoSecondary">
                <img
                  :src="[!secondaryHeader ? item.logo : item.logoSecondary]"
                  class="px-lg-0"
                  :alt="item.alt"
                  :height="item.height"
                />
              </div>
              <div v-else class="no-logo">
              </div>
            </a>
          </section>
          <!-- jáSomos section-->
          <section
            class="d-none d-lg-block col-md-6"
            v-if="template.showSomos"
          >
            <div class="somos pull-right pr-3">
              <inline-svg
                :src="template.icPeoples"
                :fill="
                  !secondaryHeader || templateStyle.surveyBackground
                    ? templateStyle.firstColor
                    : templateStyle.surveyTextColor
                "
                width="120"
                height="50"
              ></inline-svg>
              <h3
                class="extra-bold px-2"
                :class="[
                  !secondaryHeader || templateStyle.surveyBackground
                    ? 'text-first-color'
                    : 'text-survey-color',
                ]"
              >
                {{ template.somosSurveyNumber ? qtSurveyNumber : qtSomos | formatLocale }}
              </h3>

              <h4
                class="extra-bold px-1"
                :class="[
                  !secondaryHeader || templateStyle.surveyBackground
                    ? 'text-first-color'
                    : 'text-survey-color',
                ]"
              >
              {{ $t('we_are_already') }}
              </h4>
            </div>
          </section>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import InlineSvg from "vue-inline-svg";
export default {
  name: "HeaderGlobal",
  props: {
    secondaryHeader: { type: Boolean },
    qtProjNumber: { type: Number },
    qtSomos: { type: Number },
  },
  components: {
    InlineSvg,
  },
  data: () => ({
    counter: "-----",
    counterSurvey: "-----"
  }),
  created() {
    this.countHeader()
    this.getParams()
  },
  computed: {
    defaultTextColor() {
      return this.$store.state.template.style.defaultTextColor ? this.$store.state.template.style.defaultTextColor : 'white'
    },
    template() {
      return this.$store.getters.getHeaderTemplate
    },
    qtSurveyNumber(){
      return this.$store.state.qtProjNumber;
    },
    templateStyle() {
      return this.$store.state.template.style;
    },
    templateSurvey() {
      return this.$store.state.template.survey;
    },
    templateLogos() {
      return this.template.logos ? this.template.logos : []
    }
  },
  methods: {
    getParams() {
      this.params = Object.fromEntries(
        new URLSearchParams(window.location.search)
      )
    },
    countHeader1() {
      setTimeout(() => {
        let valRemaining = 15000;
        this.counter = valRemaining - this.qtSomos;
        this.counterSurvey = valRemaining - this.qtProjNumber;
      }, 2000);

      // alert(valRemaining);
    },
    countHeader() {
      let valRemaining = 15000;
      this.counter = valRemaining - this.qtSomos;
      this.counterSurvey = valRemaining - this.qtProjNumber;

      // alert(valRemaining);
    },
  },
  mounted() {
    this.countHeader();
  },
};
</script>

<style lang="scss" scoped>
.logos {
  border-radius: 0.25rem;
}

.no-logo{
  margin-top: 65px;
}
.bg-test-tag {
  background-color: #e2e2e2;
  color: #000;
  border-bottom: 1px #000 dashed;
}
</style>
